import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import { Store } from '@ngrx/store';
import { AppState } from '../store/root.state';
import * as spinnerActions from '../store/session/spinner/spinner.actions';
import { LocalStorageService } from './local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class TokenInterceptorService implements HttpInterceptor {

  constructor(private authService: AuthService,
              private localStorage:LocalStorageService,
              private store: Store<AppState>,
              ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let token: string =  this.localStorage.getSession()?.token || '';
    
    this.store.dispatch( new spinnerActions.SpinnerVisible({senderID: '', requestID:request.method,visible:true}));

    // request = request.clone({
    //   headers: request.headers.set("Permissions-Policy","fullscreen=(), geolocation=(self)")
    // });

    // request = request.clone({
    //   headers: request.headers.set("Feature-Policy:", "geolocation 'self'")
    // });

    if (!request.headers.has('Content-Type')) {
      request = request.clone({
        //headers: request.headers.set('Content-Type', 'application/json')
      });
    }else
      request = request.clone({body: request.body});

    const isApiUrlSlash = request.url.startsWith("/"+environment.apiUrl);
    const isApiUrl = request.url.startsWith(environment.apiUrl);
    
    if (token && (isApiUrl || isApiUrlSlash)) {
        if(request.url.includes("refresh-token") == false) {
          const _token = token;
          request = request.clone({
              setHeaders: { Authorization: `Bearer ${_token}`, }
          });
        }else{
          console.warn("Chiamata per refresh token no need to check it");
        }    
    }else{
      console.warn("no token in request");
    }

    return next.handle(request);
  }
}
